import { useQuery } from '@tanstack/react-query';
import { adminApi, kycApi } from '@/api';
import { useSelector } from 'react-redux';

export const useScoring = ({
  adminView,
  adminEditView,
  referralView,
  investorId,
  questionnaireId,
  questionnaire
}) => {
  const { referralToken } = useSelector((state) => state.user);
  const {
    data: dataScoring,
    isLoading: isTotalScoreLoading,
    refetch: refetchScoring
  } = useQuery({
    queryKey: ['getInvestorScoring'],
    queryFn: () =>
      adminView || adminEditView
        ? adminApi.getAdminInvestorScoring({ investorId, questionSectionTypeId: questionnaireId })
        : referralView
          ? kycApi.getReferralScoring(referralToken, questionnaireId)
          : null,
    enabled:
      (adminView || adminEditView || referralView) && questionnaire
        ? questionnaire.isScoring &&
          (questionnaire.isSelectTotalPoints || questionnaire.isSelectCategoryScoring)
        : false
  });

  return {
    dataScoring,
    isTotalScoreLoading,
    refetchScoring
  };
};
